import React from "react"
// import menu from '../scripts/menu.js';
import '../styles/index.scss';
import '../styles/utils.scss';


import Button from '../components/Button';
import Client from '../components/Client';
import Footer from '../components/Footer';
import Form from '../components/Form';
import HalfHero from '../components/HalfHero';
import Header from '../components/Header';
import Hero from '../components/Hero';
import IconList from '../components/IconList';
import Testimonial from '../components/Testimonial';
import Testimonials from '../components/Testimonials';


import kevaAfter from '../img/clients/keva-after.jpg';
import jerronSled from '../img/jerron/sled-work.jpg';

export default () => 
  <div>
    <Hero image={jerronSled}>
      <h1>CustomFIT Personal Training</h1>
      <h2>Personal training done right.</h2>
      <p>Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit. Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.</p>
      <Button to={'#get-started'}>Get Started!</Button>
    </Hero>
    <IconList title="Services">
      <li>
        <h3>Personal Training</h3>
        <p>Individual training with personal attention to teach proper techniques and monitor progress.</p>
        <Button to={'services/#personal-training'}>Learn More!</Button>
      </li>
      <li>
        <h3>Small Group Training</h3>
        <p>Great way to stay motivated and challenged with others working out alongside you.</p>
        <Button to={'services/#small-group-training'}>Learn More!</Button>
      </li>
      <li>
        <h3>Boxing</h3>
        <p>Learn the ropes from someone who has been in the ring! Not just a certified instructor.</p>
        <Button to={'services/#boxing'}>Learn More!</Button>
      </li>
      <li>
        <h3>Meal Prepping</h3>
        <p>Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.</p>
        <Button to={'services/#meal-prep'}>Learn More!</Button>
      </li>
    </IconList>
    <Client
      featured={true}
      name={'Keva S.'}
      image={kevaAfter}
      id={'keva'}>
      <p>I met Jerron November 11, 2016. I remember this day because I had less than 8 months to meet the fitness standards my job requires or be fired. I am 5’6, weighed 250 pounds and measured at 46% body fat. I admit I was skeptical, but also desperate, so I gave him a shot. Best decision I could have made! I am happy to report that 20 days before I was to be terminated, I weighed in at 191 lbs and 34% body fat. I am still happily employed and no longer worry how I’m going to support my family without a job. November 11, 2017 I weighed in at 187 pounds, 32% body fat and the gains keep coming! If you need a trainer or are just curious, go with Jerron you won’t be sorry.</p>
    </Client>
    <Testimonials
      title="Client Success Stories">
      <Testimonial
        to={'/testimonials#jennifer'}
        cite={'Jennifer T.'}>
        <p>&ldquo;The one-on-one personalized sessions put me at ease since the gym has never been my friend. In the 4 months that I have trained with CustomFIT I have successfully lost and kept off 27 pounds.&rdquo;</p>
      </Testimonial>
      <Testimonial
        to={'/testimonials#2'}
        cite={'Another Person'}>
        <p>&ldquo;The one-on-one personalized sessions put me at ease since the gym has never been my friend. In the 4 months that I have trained with CustomFIT I have successfully lost and kept off 27 pounds.&rdquo;</p>
      </Testimonial>
    </Testimonials>
  </div>



// WEBPACK FOOTER //
// ./src/pages/index.js